module.exports = __webpack_public_path__ + "img/succes.8d729f79.png";